import { Component, inject, OnInit, output } from '@angular/core';
import { MatSelectModule } from '@angular/material/select';
import { Store } from '@ngxs/store';
import { AppSelectors } from '../../../app.state';
import { SubjectJsonModel } from '../../../subject/subject.json.model';
import { TranslocoModule } from '@jsverse/transloco';

interface CompetencyCB {
  id: string
  treeId: string
  name: string
  root?: boolean
}

@Component({
  selector: 'pixl-competency-cb',
  imports: [
    MatSelectModule,
    TranslocoModule
  ],
  templateUrl: './competency-cb.component.html',
  styleUrl: './competency-cb.component.scss'
})
export class CompetencyFilterCBComponent implements OnInit {
  private store = inject(Store);
  private appState$ = this.store.select(AppSelectors.appState);

  public competencies: CompetencyCB[] = [];
  public onStateChange = output<string>();

  public ngOnInit(): void {
    this.appState$.subscribe(({ isLoaded, subjects }) => {
      if (isLoaded) {
        this.competencies = [];

        subjects.forEach((entry: SubjectJsonModel) => {
          this.competencies.push({
            id: entry.id,
            treeId: entry.treeId,
            name: entry.name,
            root: entry.root
          });
        });

        this.competencies = [...this.competencies.sort((a, b) => {
          if (a.name === '---') {
            return -1;
          }
          if (b.name === '---') {
            return 1;
          }

          return a.name.localeCompare(b.name);
        })];
      }
    });
  }

  public onChangeEvent(ev: string): void {
    this.onStateChange.emit(ev);
  }

  public getAllCompetency(): CompetencyCB[] {
    return this.competencies;
  }
}
